export const env = {
  // apiHost: "http://localhost:3033/",
  // frontUrl: "http://localhost:3000/",
  // apiHost: "https://hastyex.blfdemo.online:3033/",
  // frontUrl: "https://hastyex.blfdemo.online/",
   apiHost: "https://hastyex.online:3033/",
  frontUrl: "https://hastyex.online/",
  upload_preset: "sdfnunjedkaldkXVTLsdfojasdfsd",
  cloud_name: "daafoiwvn",
  SITE_URL: "https://hastyex.blfdemo.online/",
};
